import React, { useState } from "react";
import axios from "axios";

const CreateSliderForm = ({ refreshGallery, closeModal }) => {
  const [section, setSection] = useState("");
  const [sliderImgDescription, setSliderImgDescription] = useState("");
  const [isSlider, setIsSlider] = useState("No");
  const [images, setImages] = useState([]);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map((file) => ({
      img: file,
      imgDescription: "",
    }));
    setImages([...images, ...newImages]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("section", section);
    formData.append("sliderImgDescription", sliderImgDescription);
    formData.append("isSlider", isSlider === "Yes");

    images.forEach((image, index) => {
      formData.append("img", image.img);
      formData.append("imgDescription", image.imgDescription);
    });

    try {
      await axios.post("/api/gallery-upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Slider created successfully!");
      if (refreshGallery) refreshGallery();
      if (closeModal) closeModal();
    } catch (err) {
      console.error(err);
      alert("Error creating slider");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>Create New Slider</h3>

      <div>
        <label>Section Name</label>
        <input
          type="text"
          value={section}
          onChange={(e) => setSection(e.target.value)}
        />
      </div>

      <div>
        <label>Slider Description</label>
        <input
          type="text"
          value={sliderImgDescription}
          onChange={(e) => setSliderImgDescription(e.target.value)}
        />
      </div>

      <div>
        <label>Is this a slider?</label>
        <select value={isSlider} onChange={(e) => setIsSlider(e.target.value)}>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>

      <div>
        <label>Images</label>
        <input type="file" accept="image/*" multiple onChange={handleImageChange} />
        {images.map((image, index) => (
          <div key={index}>
            <label>Image Description {index + 1}</label>
            <input
              type="text"
              placeholder="Image description"
              onChange={(e) => {
                const newImgs = [...images];
                newImgs[index].imgDescription = e.target.value;
                setImages(newImgs);
              }}
            />
          </div>
        ))}
      </div>

      <button type="submit" style={{ marginTop: "10px" }}>Create Slider</button>
    </form>
  );
};

export default CreateSliderForm;
